"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _SttText = _interopRequireDefault(require("../../SttTypography/SttText"));
var _common = require("../../imagens/icones-modulos/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    tituloModulo: {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
      color: theme.palette.background["default"],
      fontSize: '1.25rem',
      letterSpacing: '0.0125em',
      width: '60%'
    },
    botaoSairModulo: {
      color: theme.palette.background.primary,
      cursor: 'pointer'
    },
    navigationBar: {
      width: '67%'
    },
    toolbar: {
      width: '100%',
      alignItems: 'center',
      minHeight: '45px',
      padding: '0',
      boxShadow: 'none'
    },
    iconeModulo: {
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(-1),
      width: 30,
      height: 30
    },
    indicator: {
      display: 'none'
    }
  };
});
var useStylesTab = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      color: theme.palette.background["default"],
      '&$selected': {
        backgroundColor: 'white',
        color: theme.palette.primary.main,
        borderTopLeftRadius: theme.spacing(1.5),
        borderTopRightRadius: theme.spacing(1.5)
      },
      marginBottom: '-12px',
      minWidth: 'auto',
      height: 30
    },
    selected: {},
    wrapper: {}
  };
});
var useStylesTabContainer = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginLeft: theme.spacing(1),
      height: 30
    }
  };
});
var useStylesTabAppBar = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginTop: '-1px',
      boxShadow: 'none'
    }
  };
});
var iconesModulos = (0, _common.importIconesModulos)();
var NavigationBarMobile = function NavigationBarMobile(props) {
  var classes = useStyles();
  var classesTab = useStylesTab();
  var classesTabContainer = useStylesTabContainer();
  var classeAppBar = useStylesTabAppBar();
  var submenus = props.submenus,
    _props$selectedTab = props.selectedTab,
    selectedTab = _props$selectedTab === void 0 ? 0 : _props$selectedTab,
    config = props.config;
  var renderItem = function renderItem(item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
      key: index,
      value: index,
      label: item.text,
      onClick: function onClick(e) {
        item.onClick(item, e);
      },
      classes: classesTab,
      disableRipple: true,
      "aria-controls": "menu"
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Box["default"], null, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static",
    classes: classeAppBar
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.toolbar
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.iconeModulo,
    src: iconesModulos[config.modulo_sigla]
  }), submenus && submenus.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: 4,
      width: 'calc(100% - 46px)'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    value: selectedTab,
    indicatorColor: "secondary",
    variant: "scrollable",
    classes: classesTabContainer,
    TabIndicatorProps: {
      className: classes.indicator
    }
  }, submenus.map(renderItem))) : /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    className: classes.tituloModulo
  }, config.modulo_nome)))));
};
var _default = NavigationBarMobile;
exports["default"] = _default;